export default "__VITE_PUBLIC_ASSET__548de3e2__"